import { Component, OnInit, Input } from '@angular/core';

@Component({
   selector: 'app-cpsu-subject-personal-info',
   templateUrl: './cpsu-subject-personal-info.component.html',
   styleUrls: ['./cpsu-subject-personal-info.component.scss'],
})
export class CpsuSubjectPersonalInfoComponent implements OnInit {
   @Input() subject: any;
   @Input() familyDossier: any;
   @Input() showDivider: boolean = false;
   @Input() members: any[] = [];
   constructor() {}

   ngOnInit(): void {}
}
